import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButtonGroup} from "@/components/dropdownButtonGroup/DropdownButtonGroup.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {MonitoringServersFilters} from "@/pages/monitoring/monitoringservers/MonitoringServersFilters.tsx";

interface PublicProbeServerControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const MonitoringServerControlBar = ({
  search,
  setSearch,
  filterSets,
  onFilterSetChange,
}: PublicProbeServerControlBarProps) => {
  const download = (format: string) => `${URL_ORIGINAL_WEBSITE}/monitoring/servers/export?format=${format}`;

  return (
    <ActionBarWrapper
      className={"mb-4"}
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant={"tableControlBar"} />
          <MonitoringServersFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} />
        </>
      }
      right={
        <>
          <DropdownButtonGroup
            size={"small"}
            as={"a"}
            title={"Export"}
            variant={"secondary"}
            className={"float-end"}
            href={download("csv")}
          >
            <DropdownItem href={download("xls")}>Excel</DropdownItem>
            <DropdownItem href={download("csv")}>CSV</DropdownItem>
            <DropdownItem href={download("json")}>JSON</DropdownItem>
          </DropdownButtonGroup>
        </>
      }
    />
  );
};
